import { createI18n } from "vue-i18n";

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};

  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const localePrefix = matched[1];

      // Determine the locale based on the filename prefix
      const locale = localePrefix.startsWith("en") ? "en" : "ar";
      // Merge messages to handle multiple files for the same locale
      messages[locale] = { ...messages[locale], ...locales(key) };
    }
  });
  return messages;
}

const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: process.env.VUE_APP_I18N_LOCALE || "en",
  fallbackLocale: false,
  fallbackWarn: false,
  missingWarn: false,
  silentTranslationWarn: false,
  messages: loadLocaleMessages(),
});

export default i18n;
